import Layout from "@/layouts/layout";
import Panel from "@/components/ui/Panel";
import Button from "@/components/ui/Button";
import { ButtonLink } from "@/components/ui/Button";
import { router } from "@inertiajs/react";
import { useState } from "react";
import type { SatelliteEvent } from "@/interfaces/satellite_event";

// The landing page for the link in the confirmation email. The button is the
// whole point: mail scanners fetch every link in a message, so confirming on
// page load meant Outlook and Cloudflare were confirming spots on people's
// behalf. A POST is the cheapest thing a scanner won't do.
export default function ConfirmRsvp({
  event,
  token,
  already_confirmed,
  cancelled,
  attendee_name,
}: {
  event: SatelliteEvent;
  token: string;
  already_confirmed: boolean;
  cancelled: boolean;
  attendee_name: string | null;
}) {
  const [submitting, setSubmitting] = useState(false);

  return (
    <Layout>
      <div className="mx-auto flex w-full max-w-lg flex-col gap-6 py-8">
        <Panel title="confirm-your-spot.txt">
          <div className="flex flex-col gap-4">
            <h1 className="font-display text-heading text-ink leading-tight font-bold">
              {cancelled
                ? "That spot was cancelled"
                : already_confirmed
                  ? "You're already confirmed"
                  : `One tap and you're in${attendee_name ? `, ${attendee_name}` : ""}`}
            </h1>

            <p className="text-body text-ink-muted">
              {cancelled ? (
                <>
                  This RSVP for <strong>{event.name}</strong> was cancelled. You
                  can sign up again from the event page if you'd still like to
                  come.
                </>
              ) : already_confirmed ? (
                <>
                  Your spot at <strong>{event.name}</strong> is confirmed.
                  Nothing else to do - see you there.
                </>
              ) : (
                <>
                  Press the button to confirm your spot at{" "}
                  <strong>{event.name}</strong>. This is what tells your
                  organizer you're really coming.
                </>
              )}
            </p>

            {cancelled || already_confirmed ? (
              <ButtonLink href={`/events/${event.id}`} className="self-start">
                Go to the event
              </ButtonLink>
            ) : (
              <Button
                className="self-start"
                disabled={submitting}
                onClick={() => {
                  setSubmitting(true);
                  router.post(`/rsvps/confirm/${token}`, undefined, {
                    onFinish: () => setSubmitting(false),
                  });
                }}
              >
                {submitting ? "Confirming…" : "Confirm my spot"}
              </Button>
            )}
          </div>
        </Panel>
      </div>
    </Layout>
  );
}
